import * as actions from 'client/actions'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

export default function useUpdateTrackingProperty() {
  const dispatch = useDispatch()

  return useCallback(
    property => value =>
      dispatch(actions.updateTrackingProperty(property, value)),
    [],
  )
}
